import React, { Suspense, useState } from 'react';
import { Outlet, Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { LinearProgress } from '@material-ui/core';
import { NavBar, TopBar } from './components';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  topBar: {
    zIndex: 2,
    position: 'relative'
  },
  container: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  navBar: {
    zIndex: 3,
    width: 256,
    minWidth: 256,
    flex: '0 0 auto'
  },
  content: {
    overflowY: 'auto',
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
  },
  contentInner: {
    flex: '1 1 auto',
  },
  footer: {
    flexShrink: 0,
    borderTop: '1px solid #e8ecef',
    backgroundColor: '#fff',
    padding: '10px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 8,
  },
  footerCopy: {
    fontSize: '0.72rem',
    color: '#b0bec5',
  },
  footerLinks: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  footerLink: {
    fontSize: '0.72rem',
    color: '#90a4ae',
    textDecoration: 'none',
    padding: '2px 8px',
    borderRadius: 4,
    '&:hover': {
      color: '#682622',
      backgroundColor: '#f4f6f8',
    },
  },
  footerDot: {
    width: 3,
    height: 3,
    borderRadius: '50%',
    backgroundColor: '#cfd8dc',
    flexShrink: 0,
  },
}));

const AppFooter = ({ classes }) => (
  <footer className={classes.footer}>
    <span className={classes.footerCopy}>© {new Date().getFullYear()} CGIAR / ILRI · TDGG WEB</span>
    <nav className={classes.footerLinks}>
      <RouterLink className={classes.footerLink} to="/info/about">About</RouterLink>
      <span className={classes.footerDot} />
      <RouterLink className={classes.footerLink} to="/info/privacy-policy">Privacy Policy</RouterLink>
      <span className={classes.footerDot} />
      <RouterLink className={classes.footerLink} to="/info/data-governance">Data &amp; Governance</RouterLink>
    </nav>
  </footer>
);

const Dashboard = () => {
  const classes = useStyles();
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false);

  const handleNavBarMobileOpen = () => {
    setOpenNavBarMobile(true);
  };

  const handleNavBarMobileClose = () => {
    setOpenNavBarMobile(false);
  };

  return (
    <div className={classes.root}>
      <TopBar
        className={classes.topBar}
        onOpenNavBarMobile={handleNavBarMobileOpen}
      />
      <div className={classes.container}>
        <NavBar
          className={classes.navBar}
          onMobileClose={handleNavBarMobileClose}
          openMobile={openNavBarMobile}
        />
        <main className={classes.content}>
          <div className={classes.contentInner}>
            <Suspense fallback={<LinearProgress />}>
              <Outlet />
            </Suspense>
          </div>
          <AppFooter classes={classes} />
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
